// src/MenderNext/common.ts
import { blue, cyan, grey, purple } from "@mui/material/colors";

// src/MenderNext/figma/material_colors.json
var material_colors_default = {
  collections: [
    {
      name: "material/colors",
      modes: [
        "Mode 1"
      ],
      variables: {
        "grey (M)": {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#fafafb"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#f4f4f5"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#ededee"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#dededf"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#bbbbbc"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#9c9c9d"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#737374"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#5f5f60"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#404041"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#1f1f20"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#f5f5f5"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#eeeeee"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#bdbdbd"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#616161"
            }
          }
        },
        "purple(M)": {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#f4e1eb"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#e6b5cf"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#d886af"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#cb5790"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#c33579"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#bc0a63"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#ac0d5e"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#970f57"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#820f50"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#5d0f43"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#82b1ff"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#448aff"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#2979ff"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#2962ff"
            }
          }
        },
        purple: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#f3e5f5"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#e1bee7"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#ce93d8"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#ba68c8"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#ab47bc"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#9c27b0"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#8e24aa"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#7b1fa2"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#6a1b9a"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#4a148c"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#ea80fc"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#e040fb"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#d500f9"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#aa00ff"
            }
          }
        },
        "red (M)": {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#feebee"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#fecdd2"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#ef9a9a"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#e57373"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#ef5350"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#f44336"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#e53935"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#d32f2f"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#c62828"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#b71c1c"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#ff8a80"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#ff5252"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#ff1744"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#d50000"
            }
          }
        },
        "green (M)": {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#e8f5e9"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#c8e6c9"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#a5d6a7"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#81c784"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#66bb6a"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#4caf50"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#43a047"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#388e3c"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#2e7d32"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#1b5e20"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#b9f6ca"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#69f0ae"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#00e676"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#00c853"
            }
          }
        },
        "orange (M)": {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#fff3e0"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#ffe0b2"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#ffcc80"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#ffb74d"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#ffa726"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#ff9800"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#fb8c00"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#f57c00"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#ef6c00"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#e65100"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#ffd180"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#ffab40"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#ff9100"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#ff6d00"
            }
          }
        },
        lightBlue: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#e1f5fe"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#b3e5fc"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#81d4fa"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#4fc3f7"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#29b6f6"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#03a9f4"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#039be5"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#0288d1"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#0277bd"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#01579b"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#80d8ff"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#40c4ff"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#00b0ff"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#0091ea"
            }
          }
        },
        indigo: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#e8eaf6"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#c5cae9"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#9fa8da"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#7986cb"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#5c6bc0"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#3f51b5"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#3949ab"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#303f9f"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#283593"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#1a237e"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#8c9eff"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#536dfe"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#3d5afe"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#304ffe"
            }
          }
        },
        deepPurple: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#ede7f6"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#d1c4e9"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#b39ddb"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#9575cd"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#7e57c2"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#673ab7"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#5e35b1"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#512da8"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#4527a0"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#311b92"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#b388ff"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#7c4dff"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#651fff"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#6200ea"
            }
          }
        },
        amber: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#fff8e1"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#ffecb3"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#ffe082"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#ffd54f"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#ffca28"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#ffc107"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#ffb300"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#ffa000"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#ff8f00"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#ff6f00"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#ffe57f"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#ffd740"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#ffc400"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#ffab00"
            }
          }
        },
        pink: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#fce4ec"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#f8bbd0"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#f48fb1"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#f06292"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#ec407a"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#e91e63"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#d81b60"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#c2185b"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#ad1457"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#880e4f"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#ff80ab"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#ff4081"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#f50057"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#c51162"
            }
          }
        },
        deepOrange: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#fbe9e7"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#ffccbc"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#ffab91"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#ff8a65"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#ff7043"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#ff5722"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#f4511e"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#e64a19"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#d84315"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#bf360c"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#ff9e80"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#ff6e40"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#ff3d00"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#dd2c00"
            }
          }
        },
        lightGreen: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#f1f8e9"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#dcedc8"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#c5e1a5"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#aed581"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#8bc34a"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#8bc34a"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#7cb342"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#689f38"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#558b2f"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#33691e"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#ccff90"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#b2ff59"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#76ff03"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#64dd17"
            }
          }
        },
        lime: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#f9fbe7"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#f0f4c3"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#e6ee9c"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#dce775"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#d4e157"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#cddc39"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#c0ca33"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#afb42b"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#9e9d24"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#827717"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#f4ff81"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#eeff41"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#c6ff00"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#aeea00"
            }
          }
        },
        yellow: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#fffde7"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#fff9c4"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#fff59d"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#fff176"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#ffee58"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#ffeb3b"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#fdd835"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#fbc02d"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#f9a825"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#f57f17"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#ffff8d"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#ffff00"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#ffea00"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#ffd600"
            }
          }
        },
        "cyan (M)": {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#e1f5fd"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#b5e7f9"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#85d8f4"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#56c8ed"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#39bde5"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#2fb2dd"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#28a3c9"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#1d8faf"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#147b96"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#015969"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#84ffff"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#18ffff"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#00e5ff"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#00b8d4"
            }
          }
        },
        teal: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#e0f2f1"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#b2dfdb"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#80cbc4"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#4db6ac"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#26a69a"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#009688"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#00897b"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#00796b"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#00695c"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#004d40"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#a7ffeb"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#64ffda"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#1de9b6"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#00bfa5"
            }
          }
        },
        blueGrey: {
          "50": {
            type: "color",
            values: {
              "Mode 1": "#eceff1"
            }
          },
          "100": {
            type: "color",
            values: {
              "Mode 1": "#cfd8dc"
            }
          },
          "200": {
            type: "color",
            values: {
              "Mode 1": "#b0bec5"
            }
          },
          "300": {
            type: "color",
            values: {
              "Mode 1": "#90a4ae"
            }
          },
          "400": {
            type: "color",
            values: {
              "Mode 1": "#78909c"
            }
          },
          "500": {
            type: "color",
            values: {
              "Mode 1": "#607d8b"
            }
          },
          "600": {
            type: "color",
            values: {
              "Mode 1": "#546e7a"
            }
          },
          "700": {
            type: "color",
            values: {
              "Mode 1": "#455a64"
            }
          },
          "800": {
            type: "color",
            values: {
              "Mode 1": "#37474f"
            }
          },
          "900": {
            type: "color",
            values: {
              "Mode 1": "#263238"
            }
          },
          A100: {
            type: "color",
            values: {
              "Mode 1": "#cfd8dc"
            }
          },
          A200: {
            type: "color",
            values: {
              "Mode 1": "#b0bec5"
            }
          },
          A400: {
            type: "color",
            values: {
              "Mode 1": "#78909c"
            }
          },
          A700: {
            type: "color",
            values: {
              "Mode 1": "#455a64"
            }
          }
        }
      }
    }
  ]
};

// src/MenderNext/figma/typography.json
var typography_default = {
  collections: [
    {
      name: "typography",
      modes: [
        "Mode 1"
      ],
      variables: {
        fontFamily: {
          type: "string",
          values: {
            "Mode 1": "Red Hat Display"
          }
        },
        fontWeightLight: {
          type: "number",
          values: {
            "Mode 1": 300
          }
        },
        fontWeightRegular: {
          type: "number",
          values: {
            "Mode 1": 400
          }
        },
        fontWeightMedium: {
          type: "number",
          values: {
            "Mode 1": 500
          }
        },
        fontWeightBold: {
          type: "number",
          values: {
            "Mode 1": 700
          }
        },
        _fontSize: {
          "1rem": {
            type: "number",
            values: {
              "Mode 1": 16
            }
          },
          "0,75rem": {
            type: "number",
            values: {
              "Mode 1": 12
            }
          },
          "0,875rem": {
            type: "number",
            values: {
              "Mode 1": 14
            }
          },
          "1,25rem": {
            type: "number",
            values: {
              "Mode 1": 20
            }
          },
          "1,5rem": {
            type: "number",
            values: {
              "Mode 1": 24
            }
          },
          "2,125rem": {
            type: "number",
            values: {
              "Mode 1": 34
            }
          },
          "3rem": {
            type: "number",
            values: {
              "Mode 1": 48
            }
          },
          "3,75rem": {
            type: "number",
            values: {
              "Mode 1": 60
            }
          },
          "6rem": {
            type: "number",
            values: {
              "Mode 1": 96
            }
          },
          "0,625rem": {
            type: "number",
            values: {
              "Mode 1": 10
            }
          },
          "0,8125rem": {
            type: "number",
            values: {
              "Mode 1": 13
            }
          },
          "0,9375rem": {
            type: "number",
            values: {
              "Mode 1": 15
            }
          }
        },
        fontWeightSemiBold: {
          type: "number",
          values: {
            "Mode 1": 600
          }
        },
        "fontFamily (body)": {
          type: "string",
          values: {
            "Mode 1": "Red Hat Text"
          }
        }
      }
    }
  ]
};

// src/MenderNext/common.ts
var typographyTokens = typography_default.collections.find(({ name }) => name === "typography");
var colorTokens = material_colors_default.collections.find(({ name }) => name === "material/colors");
var typography = {
  fontFamily: typographyTokens?.variables.fontFamily.values["Mode 1"],
  body1: {
    fontFamily: typographyTokens?.variables["fontFamily (body)"].values["Mode 1"]
  }
};
var colors = {
  grey: {
    ...grey,
    50: colorTokens?.variables["grey (M)"]["50"].values["Mode 1"] || grey[50],
    100: colorTokens?.variables["grey (M)"]["100"].values["Mode 1"] || grey[100],
    200: colorTokens?.variables["grey (M)"]["200"].values["Mode 1"] || grey[200],
    300: colorTokens?.variables["grey (M)"]["300"].values["Mode 1"] || grey[300],
    400: colorTokens?.variables["grey (M)"]["400"].values["Mode 1"] || grey[400],
    500: colorTokens?.variables["grey (M)"]["500"].values["Mode 1"] || grey[500],
    600: colorTokens?.variables["grey (M)"]["600"].values["Mode 1"] || grey[600],
    700: colorTokens?.variables["grey (M)"]["700"].values["Mode 1"] || grey[700],
    800: colorTokens?.variables["grey (M)"]["800"].values["Mode 1"] || grey[800],
    900: colorTokens?.variables["grey (M)"]["900"].values["Mode 1"] || grey[900]
  },
  purple: {
    ...blue,
    // ...remainder colors (A100 - A700) should be based on 'blue'
    50: colorTokens?.variables["purple(M)"]["50"].values["Mode 1"] || purple[50],
    100: colorTokens?.variables["purple(M)"]["100"].values["Mode 1"] || purple[100],
    200: colorTokens?.variables["purple(M)"]["200"].values["Mode 1"] || purple[200],
    300: colorTokens?.variables["purple(M)"]["300"].values["Mode 1"] || purple[300],
    400: colorTokens?.variables["purple(M)"]["400"].values["Mode 1"] || purple[400],
    500: colorTokens?.variables["purple(M)"]["500"].values["Mode 1"] || purple[500],
    600: colorTokens?.variables["purple(M)"]["600"].values["Mode 1"] || purple[600],
    700: colorTokens?.variables["purple(M)"]["700"].values["Mode 1"] || purple[700],
    800: colorTokens?.variables["purple(M)"]["800"].values["Mode 1"] || purple[800],
    900: colorTokens?.variables["purple(M)"]["900"].values["Mode 1"] || purple[900]
  },
  cyan: {
    ...cyan,
    50: colorTokens?.variables["cyan (M)"]["50"].values["Mode 1"] || cyan[50],
    100: colorTokens?.variables["cyan (M)"]["100"].values["Mode 1"] || cyan[100],
    200: colorTokens?.variables["cyan (M)"]["200"].values["Mode 1"] || cyan[200],
    300: colorTokens?.variables["cyan (M)"]["300"].values["Mode 1"] || cyan[300],
    400: colorTokens?.variables["cyan (M)"]["400"].values["Mode 1"] || cyan[400],
    500: colorTokens?.variables["cyan (M)"]["500"].values["Mode 1"] || cyan[500],
    600: colorTokens?.variables["cyan (M)"]["600"].values["Mode 1"] || cyan[600],
    700: colorTokens?.variables["cyan (M)"]["700"].values["Mode 1"] || cyan[700],
    800: colorTokens?.variables["cyan (M)"]["800"].values["Mode 1"] || cyan[800],
    900: colorTokens?.variables["cyan (M)"]["900"].values["Mode 1"] || cyan[900]
  }
};

export {
  typography,
  colors
};
//# sourceMappingURL=chunk-LXMSSK5D.js.map